export const DEFAULT_PAGE_TITLE =
  "Bibow Playground Rentals | Kids' Playground Rental in Valenzuela";
export const DEFAULT_PAGE_DESCRIPTION =
  "Mobile kids' playground rental for birthdays and parties in Valenzuela, Metro Manila and Bulacan. Setup, a playground assistant and pack-away included.";

const SITE_NAME = "Bibow Playground Rentals";

/**
 * Titles and descriptions for the fixed public pages. Search engines that run
 * JavaScript (Google) read these; link previews in Messenger and Facebook use
 * the site-wide tags written into index.html by scripts/generate-seo.mjs.
 */
const ROUTE_SEO: Record<string, { title: string; description: string }> = {
  "/packages": {
    title: `Playground Packages & Prices | ${SITE_NAME}`,
    description:
      "Compare Bibow mobile playground packages, inflatables and add-ons for birthdays and family celebrations.",
  },
  "/about": {
    title: `About Bibow | ${SITE_NAME}`,
    description:
      "Meet Bibow: mobile playgrounds we deliver, set up, assist during play and pack away, so parents can enjoy the party too.",
  },
  "/reviews": {
    title: `Parent Reviews | ${SITE_NAME}`,
    description: "Read what parents say about celebrating with Bibow mobile playgrounds.",
  },
  "/book": {
    title: `Book a Mobile Playground | ${SITE_NAME}`,
    description:
      "Check open dates and request your Bibow mobile playground online. Pay the booking fee now or later.",
  },
};

/** `/home` serves the same page as `/`, so both point search engines at `/`. */
const CANONICAL_ALIASES: Record<string, string> = { "/home": "/" };

function metaTag(name: string): HTMLMetaElement | null {
  if (typeof document === "undefined") return null;
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  return tag;
}

/**
 * Points the canonical link at the main domain's version of this path. The
 * origin comes from the build-time tag, so pages opened on the old workers.dev
 * address still name bibow-playground.com as the original.
 */
function setCanonical(path: string) {
  const link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) return;
  const origin = new URL(link.href, window.location.href).origin;
  link.href = origin + (CANONICAL_ALIASES[path] ?? path);
}

export function applyRouteSeo(path: string) {
  if (typeof document === "undefined") return;
  const route = ROUTE_SEO[path];
  document.title = route?.title ?? DEFAULT_PAGE_TITLE;
  metaTag("description")?.setAttribute("content", route?.description ?? DEFAULT_PAGE_DESCRIPTION);
  setCanonical(path);
}

/** Restores the current route's defaults, e.g. after a CMS page unmounts. */
export function resetPageSeo() {
  if (typeof window === "undefined") return;
  applyRouteSeo(window.location.pathname);
}

export function applyPageSeo(title?: string | null, description?: string | null) {
  if (typeof document === "undefined") return;
  if (title) document.title = title;
  if (description) metaTag("description")?.setAttribute("content", description);
}
